import { api } from "api/base";

export const getDrivers = async () => {
    const response = await api.get('/drivers');
    return response.data;
};

